import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { PlatformService } from '../services/platform.service';

/**
 * 인증 가드 Fn
 *
 * @remarks
 *
 * 로그아웃 라우팅 설정 없이 redirect 설정만 있으면
 * 무한 loop 에 빠지므로 주의
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const platformService = inject(PlatformService);

  // 서버는 무조건 통과
  if (platformService.isPlatformServer) {
    return true;
  }

  // 🔴 "지금 유효한가"가 아니라 "이어갈 수 있는가"로 판정한다 — AuthService.hasSession() 참조.
  //
  // isAuthenticated() 단독으로 바꿨다가 액세스 토큰 만료(약 1시간)마다 재로그인을 요구하는
  // 회귀를 만들었다(2026-08-04 적발·수정). 만료된 액세스 토큰은 정상 상태이고, 인터셉터가
  // 401 에서 조용히 갱신한다. refresh 도 실패하면 그때 인터셉터가 로그아웃시킨다.
  if (!authService.hasSession()) {
    // 로그아웃
    return router.parseUrl('/logout');
  }

  return authService.getAccount$().pipe(
    map((account) => {
      if (account) {
        return true;
      }

      return router.parseUrl('/logout');
    }),
    catchError(() => {
      return of(router.parseUrl('/logout'));
    }),
  );
};
